import SET_FETCH_ERROR from "./actionTypes";

// eslint-disable-next-line import/prefer-default-export
export const setError = value => ({
  type: SET_FETCH_ERROR,
  value: value || false
});
